<template>
    <div :style="{ 'background' : data.impairedRegime ? '#ffffff' : '#f2f2f2' }" class="outer">
        <img v-if="data.impairedRegime" :style="{ 'filter' : 'grayscale(1)', '-webkit-filter' : 'grayscale(1)' }" src="/media/error/undraw_Taken.png" alt="">
        <img v-else src="/media/error/undraw_Taken.png" alt="">
    </div>
</template>
<script>
export default {
    props: [ 'data' ]
}
</script>
<style lang="scss" scoped>
    .outer{
        height: 684px;
        transition: all 0.6s ease;
        img{
            margin: 120px auto 150px auto;
            position: absolute;
            transform: scale(0.25) translateX(-205%) translateY(-150%);
        }
    }
    @media only screen and (max-width: 1024px){
        .outer{
            height: 540px;
            img{
                margin: 70px auto 120px auto;
            }
        }
    }
    @media only screen and (max-width: 720px){
        .outer{
            height: 440px;
            img{
                transform: scale(0.2) translateX(-250%) translateY(-200%);
            }
        }
    }
    @media only screen and (max-width: 480px){
        .outer{
            height: 360px;
            img{
                transform: scale(0.15) translateX(-330%) translateY(-290%);
            }
        }
    }
</style>


